<h3>
  @if (org()) {
    Företag
  } @else {
    Kunder
  }
</h3>
<div class="list">
  @for (owner of formIterable; track $index) {
    <div class="owner">
      <spb-input-field
        [label]="org() ? 'Organisationsnummer' : 'Personnummer'"
        [personNummer]="true"
        [field]="ownerForm[$index].sub"
        [name]="ownerForm[$index].name"
      />
      @if (owners().length > 1) {
        <button matIconButton
                (click)="remove($index)">
          <mat-icon class="negative">delete</mat-icon>
        </button>
      }
    </div>

  }
  <button matButton (click)="add()">
    <mat-icon>add_circle</mat-icon>
    Lägg till
  </button>
</div>